module.exports = __webpack_public_path__ + "img/200528_ERG-19-2886_Flyer_SBU_Schueler_RZ.089a9fe7.jpg";